import { setup, fromPromise, assertEvent } from 'xstate5'
import { type Emits as EmitsCreateExternalServiceRequestPure } from '@/components/PmCreateExternalServiceRequest/PmCreateExternalServiceRequestPure.vue'
import { assertFriendlyError } from '@/functional/friendlyErrors'

export const PmCreateExternalServiceRequestState = setup({
  types: {
    events: {} as {
      type: 'create'
      variables: EmitsCreateExternalServiceRequestPure['submit']
    },

    context: {} as {
      error: string | undefined
      errorDetails: string[] | undefined
    },
  },

  actions: {
    showSuccessNotification: () => {
      throw new Error('showSuccessNotification not implemented')
    },

    emitClose: () => {
      throw new Error('emitClose not implemented')
    },
  },

  actors: {
    createExternalServiceRequest: fromPromise<
      void,
      { variables: EmitsCreateExternalServiceRequestPure['submit'] }
    >(async () => {
      throw new Error('createExternalServiceRequest not implemented')
    }),
  },
}).createMachine({
  id: 'PmCreateExternalServiceRequestState',
  initial: 'default',

  context: {
    error: undefined,
    errorDetails: undefined,
  },

  states: {
    default: {
      on: {
        create: 'create',
      },
    },

    create: {
      initial: 'saving',

      states: {
        saving: {
          invoke: {
            id: 'createExternalServiceRequest',
            src: 'createExternalServiceRequest',
            input: ({ event }) => {
              assertEvent(event, 'create')
              return { variables: event.variables }
            },
            onDone: {
              target: 'success',
            },
            onError: {
              target: 'error',
              actions: ({ context, event }) => {
                assertFriendlyError(event.error)

                context.error = event.error.message
                context.errorDetails = event.error.details
              },
            },
          },
        },
        error: {
          on: {
            create: '#PmCreateExternalServiceRequestState.create',
          },
        },
        success: {
          entry: ['showSuccessNotification', 'emitClose'],
          type: 'final',
        },
      },
    },
  },
})
